import { DebugScriptBreakpointSettingsControl } from '../debugconsole/workflow/debug.script.breakpoint.control';
import { KeyboardShortcuts } from '../helpers/keyboard.helper';
import { AgentService } from '../services/agent.service';
import { APIKeyService } from '../services/apikeys.service';
import { AppBuilderSettingsService } from '../services/appbuildersettings.service';
import { CapsuleService } from '../services/capsule.service';
import { ChangeLogService } from '../services/changelog.service';
import { CollaborationService } from '../services/collaboration.service';
import { ConfigService } from '../services/config.service';
import { ConnectorService } from '../services/connector.service';
import { CustomRestService } from '../services/customrest.service';
import { DataService } from '../services/data.service';
import {
    ContainerEnumService, DataModelService, SelfServiceObjectService, SelfServiceSecurityService
} from '../services/datamodel.service';
import { DBUserService } from '../services/dbuser.service';
import { DebugService } from '../services/debug.service';
import { DocumentationService } from '../services/documentation.service';
import { DynamicDataService } from '../services/dynamicdata.service';
import { FormulaService } from '../services/formula.service';
import { GeneralSettingsService } from '../services/generalsettings.service';
import { GitService } from '../services/git.service';
import { GlobalVariableService } from '../services/globalvariable.service';
import { IntegrationService } from '../services/integration.service';
import { JiraService } from '../services/jira.service';
import { LayoutService } from '../services/layout.service';
import { LogsService } from '../services/logs.service';
import { MailSettingsService } from '../services/mailsettings.service';
import { MediaService } from '../services/media.service';
import { MetaService, OutputService } from '../services/meta.service';
import { MonitoringService } from '../services/monitoring.service';
import { NumberCircleService } from '../services/numbercircle.service';
import { OAuthService } from '../services/oauth.service';
import { OfflineService } from '../services/offline.service';
import { GADateTimeAdapter, GAIntl } from '../services/owl.services';
import { PermissionsService } from '../services/permissions.service';
import { StandardRequestBase } from '../services/request-base';
import { RolesService } from '../services/roles.service';
import { SchedulerService } from '../services/scheduler.service';
import { ScriptLibraryService } from '../services/scriptlibrary.service';
import { SecurityService } from '../services/security.service';
import { SettingsService } from '../services/settings.service';
import { SmartSyncService } from '../services/smart.sync.service';
import { TranslationService } from '../services/translation.service';
import { UsersService } from '../services/users.service';
import { UserSettingsService } from '../services/usersettings.service';
import { VersioningService } from '../services/versioning.service';
import { WebHookService } from '../services/webhook.service';
import { WebPushService } from '../services/webpush.service';
import { WebsocketService } from '../services/websocket.service';
import { WorkerInfoService } from '../services/worker.info.service';
import { WorkerService } from '../services/worker.service';
import { WorkflowService } from '../services/workflow.service';

export const APP_SERVICES = [
    AppBuilderSettingsService,
    SettingsService,
    LayoutService,
    DataService,
    MetaService,
    KeyboardShortcuts,
    WorkflowService,
    DataModelService,
    DynamicDataService,
    MediaService,
    StandardRequestBase,
    UsersService,
    SecurityService,
    ContainerEnumService,
    WebsocketService,
    FormulaService,
    RolesService,
    PermissionsService,
    LogsService,
    SchedulerService,
    GlobalVariableService,
    SelfServiceSecurityService,
    SelfServiceObjectService,
    TranslationService,
    ScriptLibraryService,
    JiraService,
    AgentService,
    UserSettingsService,
    OfflineService,
    GeneralSettingsService,
    WebHookService,
    DebugService,
    OutputService,
    CustomRestService,
    MailSettingsService,
    NumberCircleService,
    ConnectorService,
    CollaborationService,
    MonitoringService,
    GitService,
    WebPushService,
    WorkerService,
    GADateTimeAdapter,
    GAIntl,
    CapsuleService,
    ChangeLogService,
    VersioningService,
    DocumentationService,
    ConfigService,
    IntegrationService,
    SmartSyncService,
    APIKeyService,
    WorkerInfoService,
    OAuthService,
    DBUserService,
    { provide: LayoutService.CONTAINER_DATA, useValue: undefined },
    { provide: DebugScriptBreakpointSettingsControl.SCRIPT_DEBUG_DATA, useValue: undefined }
];
